module.exports = __webpack_public_path__ + "media/E_talk.773772a7.mp3";